import { useMutation, UseMutationOptions, useQueryClient } from "@tanstack/react-query";
import { NotiflowWithSteps } from "@/types";
import { api, UnprocessableEntityError } from "@/utils/api";
import { camelize, underscore } from "@/utils/api-helpers";

export type UpdateNotiflowInput = {
  name?: string;
  active?: boolean;
  includeInPreferences?: boolean;
  steps?: NotiflowWithSteps["flow"];
};

export const useUpdateNotiflow = (
  projectId: string,
  notiflowId: string,
  options: Omit<UseMutationOptions<NotiflowWithSteps, UnprocessableEntityError, UpdateNotiflowInput, unknown>, "mutationFn"> = {}
) => {
  const queryClient = useQueryClient();

  return useMutation<NotiflowWithSteps, UnprocessableEntityError, UpdateNotiflowInput, unknown>({
    mutationFn: async (input: UpdateNotiflowInput): Promise<NotiflowWithSteps> => {
      const response = await api.patch<NotiflowWithSteps>(`/projects/${projectId}/notiflows/${notiflowId}`, underscore(input));
      return camelize(response.data);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["projects", projectId, "notiflows"],
      });
      queryClient.invalidateQueries({
        queryKey: ["projects", projectId, "notiflows", notiflowId],
      });
    },
    ...options
  });
};
